const getters = {
  oneMenu: state => state.menu.oneMenu || [],
  twoMenu: state => state.menu.twoMenu || [],
  allMenu: state => state.menu.allMenu || [],
  // 案件详情
  caseInfo: state => state.app.caseDetails.caseInfo || {},
  // 当事人
  party: state => state.app.caseDetails.party || {},
  // 证据
  evidences: state => state.app.caseDetails.evidences || {},
  // 审核记录
  audits: state => state.app.caseDetails.audits || {},
  // 问题
  questions: state => state.app.caseDetails.questions || {},
  // 答辩
  replys: state => state.app.caseDetails.replys || [],
  // 其他文件
  submits: state => state.app.caseDetails.submits || [],
  // 费用
  fees: state => state.app.caseDetails.fees || {},
  // 仲裁通知
  letters: state => state.app.caseDetails.letters || {},
  // 判决书
  judge: state => state.app.caseDetails.judge || {},
  // 仲裁员回避、管辖异议审核记录
  powers: state => state.app.caseDetails.powers || [],
  // 管辖异议答辩
  powerReply: state => state.app.caseDetails.powersReply || [],
  // 操作日志
  operateLog: state => state.app.caseDetails.operateLog || [],
  // 反请求
  reverser: state => state.app.caseDetails.reverser && state.app.caseDetails.reverser[0],
  // 意见反馈表
  feedback: state => state.app.caseDetails.feedback || [],
  // 其他请求
  otherApply: state => state.app.caseDetails.otherApply || [],

  statusDic: state => state.app.statusDic,
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js